import type { KeyboardEvent } from "react";
import { cn } from "#scripts/lib/utils.ts";
import type { AutocompleteVM } from "../types.ts";
import { LiveValue } from "./LiveValue.tsx";

interface AutocompleteInputProps {
  vm: AutocompleteVM;
}

export function AutocompleteInput({ vm }: AutocompleteInputProps) {
  return (
    <div data-loc="phosphor-blog/content/_sources/autocomplete-demo/components/AutocompleteInput.tsx:12:10" data-name="div" className="relative w-full">
      <LiveValue query={vm.inputText$}>
        {(inputText: string) => {
          const handleKeyDown = (e: KeyboardEvent<HTMLTextAreaElement>) => {
            switch (e.key) {
              case "ArrowDown":
                e.preventDefault();
                vm.pressKey("down");
                break;
              case "ArrowUp":
                e.preventDefault();
                vm.pressKey("up");
                break;
              case "Enter":
                e.preventDefault();
                vm.pressKey("enter");
                break;
              case "Escape":
                e.preventDefault();
                vm.pressKey("escape");
                break;
            }
          };

          return (
            <>
              <textarea
                value={inputText}
                onChange={(e) => {
                  const target = e.currentTarget;
                  vm.updateInput(target.value, target.selectionStart);
                }}
                onKeyDown={handleKeyDown}
                placeholder="Type @ followed by a filename..."
                data-loc="phosphor-blog/content/_sources/autocomplete-demo/components/AutocompleteInput.tsx:46:17" className="w-full px-3 py-2 text-sm border border-border rounded-md bg-bg-elevated text-text resize-none focus:outline-hidden focus:ring-2 focus:ring-primary/50"
                rows={3}
              />
              <LiveValue query={vm.options$}>
                {(options) =>
                  options.length > 0 && (
                    <div data-loc="phosphor-blog/content/_sources/autocomplete-demo/components/AutocompleteInput.tsx:52:26" data-name="div" className="absolute z-10 w-full mt-1 bg-bg-elevated border border-border rounded-md shadow-lg max-h-60 overflow-auto">
                      {options.map((option) => (
                        <LiveValue key={option.key} query={option.selected$}>
                          {(isSelected: boolean) => (
                            <button
                              type="button"
                              onClick={() => option.click()}
                              data-loc="phosphor-blog/content/_sources/autocomplete-demo/components/AutocompleteInput.tsx:59:31" data-name="button" className={cn(
                                "w-full px-3 py-2 text-left text-sm hover:bg-border/30 transition-colors",
                                isSelected && "bg-border/20 border-l-accent text-accent",
                              )}
                            >
                              <span data-loc="phosphor-blog/content/_sources/autocomplete-demo/components/AutocompleteInput.tsx:64:37" data-name="span" className="font-mono text-xs">{option.label}</span>
                            </button>
                          )}
                        </LiveValue>
                      ))}
                    </div>
                  )
                }
              </LiveValue>
            </>
          );
        }}
      </LiveValue>
    </div>
  );
}
